import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { StatusCodeResponseService } from '../services/status-code-response.service';

export const notFoundGuard: CanActivateFn = (route, state) => {
  const statusCodeResponseService = inject(StatusCodeResponseService);
  statusCodeResponseService.setNotFound();
  return true;
};
